export const getCloudinaryUrl = (imageDomain, imagePath, height, width, format = 'jpg') => {
  const parameters = `c_fill,w_${width},h_${height},f_${format},q_auto:eco,g_faces`;
  return `${imageDomain}/image/upload/${parameters}${imagePath}`;
};

export const getCloudinaryUrlBackgroundImage = (imageDomain, backgroundImage, width, height, format = 'jpg') => { 
  const x = Math.round(backgroundImage.focalPoint?.leftPixel);
  const y = Math.round(backgroundImage.focalPoint?.topPixel);
  return `${imageDomain}/image/upload/c_fill,w_${width},h_${height},f_${format},q_auto:eco,g_xy_center,x_${x},y_${y}${backgroundImage.mediaUrl}`;
};

export const getBackgroundImageStyling = (className, imageDomain, backgroundImage) => {
  return backgroundImage?.mediaUrl ? `
  .${className} {
    background-size: cover;
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 975, 1368, 'jpg')}");
  }
  @media screen and (max-width: 375px) and (max-height: 700px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 375, 700, 'jpg')}"); }
  }
  @media screen and (max-width: 375px) and (min-height: 701px) and (max-height: 900px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 375, 900, 'jpg')}"); }
  }
  @media screen and (min-width: 376px) and (max-width: 414px) and (max-height: 915px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 415, 915, 'jpg')}"); }
  }
  @media screen and (min-width: 415px) and (max-width: 767px) and (max-height: 915px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 767, 915, 'jpg')}"); }
  }
  @media screen and (min-width: 767px) and (max-height: 700px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 975, 700, 'jpg')}"); }
  }
  @media screen and (min-width: 767px) and (max-width: 974px) and (min-height: 701px) and (max-height: 1024px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 975, 1024, 'jpg')}"); }
  }
  @media screen and (min-width: 700px) and (max-width: 974px) and (min-height: 1025px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 975, 1368, 'jpg')}"); }
  }
  @media screen and (min-width: 975px) { .${className} { 
    background-image: url("${getCloudinaryUrlBackgroundImage(imageDomain, backgroundImage, 975, 700, 'jpg')}"); }
  }` : '';
};

export const getCloudinaryUrlFlightTimeImage = (imageDomain, imagePath, width, format = 'jpg') => {
  return `${imageDomain}/image/upload/c_fill,w_${width},f_${format},q_auto:low${imagePath}`;
};

export const getCloudinarySources = (mediaString, imageDomain, imagePath, height, width) => {
  
  return [
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'avif'),
      type: 'image/avif',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'jp2'),
      type: 'image/jp2',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'webp'),
      type: 'image/webp',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width),
      type: 'image/jpeg',
    },
  ];
};
